<template>
    <div class="row header">
        <router-link :to="{ name: 'projects-index' }" class="col-sm-2">
            <img src="@images/dotag-logo.png" alt="">
        </router-link>
        <div class="col-sm-10">
            <div class="header-menu">
                <!--<a href="" class="back-link">Back</a>-->
                <!--<span class="icon support"></span>-->
                <!--<span class="icon box"></span>-->

                <div v-if="$store.state.company.id">
                    <router-link :to="{ name: 'company-users-index', params: { company_id : $store.state.company.id }}"
                        class="icon settings">
                    </router-link>
                </div>

                <div class="btn-group">
                    <b-dropdown :text="(user && user.name) ?  'Hello ' + user.name : 'Menu'"
                                toggle-class="text-decoration-none"
                                variant="none"
                                size="sm">
                        <b-dropdown-item @click="$emit('logout')">Logout</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import idb from "@mobile/store/idb";
    import '@css/settings-create-project.css';

    export default {
        data() {
            return {
                user: null,
                companyID: null
            }
        },
        mounted() {
            idb.getUser().then(r => {
                this.user = r;
            });

            this.companyID = this.$store.state.company.id;
        },
        methods: {}
    }
</script>
